var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle-root",style:(_vm.rootStyle)},[_c('div',{staticClass:"circle-content",style:(_vm.contentStyle)},[_vm._t("default")],2),_vm._v(" "),_vm._t("over")],2)}
var staticRenderFns = []

export { render, staticRenderFns }